import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

Highcharts.setOptions({
    lang: {
        rangeSelectorZoom: 'Filter'
    }
});

const DashChart = ({ totaldeposits, totaldepositamounts, totalregistrations, totalviews, totalclicks, totaldirectlinks, totalcommission, hiddenLengend = [], loading }) => {
    const options = {
        rangeSelector: {
            selected: 2,
            buttons: [
                {
                    type: 'week',
                    text: '1w',
                    count: 1,
                },
                {
                    type: 'month',
                    text: '1m',
                    count: 1
                },
                {
                    type: 'all',
                    text: 'All'
                }
            ],
            inputEnabled: false
        },
        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e %b',
                week: '%e %b',
                month: '%e %b',
                year: '%e %b'
            }
        },
        title: {
            text: null
        },
        series: [
            {
                name: 'Total deposits',
                data: totaldeposits,
                tooltip: {
                }
            },
            {
                name: 'Total deposits amount',
                data: totaldepositamounts,
                tooltip: {
                    valueDecimals: 2
                }
            },
            {
                name: 'Total registrations',
                data: totalregistrations,
                tooltip: {
                }
            },
            {
                name: 'Total views',
                data: totalviews,
                tooltip: {
                }
            },
            {
                name: 'Total clicks',
                data: totalclicks,
                tooltip: {
                }
            },
            {
                name: 'Total direct links',
                data: totaldirectlinks,
                tooltip: {
                }
            },

            {
                name: 'Total commission',
                data: totalcommission,
                tooltip: {
                    valueDecimals: 2
                },

            }
        ],
        legend: {
            enabled: true
        }
    };

    return <HighchartsReact highcharts={Highcharts} constructorType={'stockChart'} options={options} />;
};

export default DashChart;